(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-order--template"]) return;
  try {
    
  document.querySelector('.bulk__form .btn').addEventListener('click', (e) => {

    let hasError = false;

    const showError = (errorElement, message) => {
      if (message) {
        errorElement.textContent = message;
        errorElement.classList.add('error');
        hasError = true;
      } else {
        errorElement.textContent = '';
        errorElement.classList.remove('error');
      }
    };

    // Name validation
    const nameInput = document.getElementById('name');
    const nameError = document.getElementById('error-contact-name');
    showError(nameError, nameInput.value.trim() === '' ? 'Please add your name.' : '');

    // Email validation
    const emailInput = document.getElementById('email-address');
    const emailError = document.getElementById('error-contact-email');
    const emailValue = emailInput.value.trim();
    if (emailValue === '') {
      showError(emailError, 'Please add your email address.');
    } else if (!/^\S+@\S+\.\S+$/.test(emailValue)) {
      showError(emailError, 'Please enter a valid email address.');
    } else {
      showError(emailError, '');
    }

    // Phone number validation
    const phoneInput = document.getElementById('phone-number');
    const phoneError = document.getElementById('error-contact-phone');
    const phoneValue = phoneInput.value.trim();
    if (phoneValue === '') {
      showError(phoneError, 'Please add your phone number.');
    } else if (!/^\d{3}-\d{3}-\d{4}$/.test(phoneValue)) {
      showError(phoneError, 'Please enter a valid phone number (e.g., 555-555-5555).');
    } else {
      showError(phoneError, '');
    }

    // Number of locations validation
    const locationError = document.getElementById('error-contact-number-of-locations');
    const single = document.getElementById('location-count-single').checked;
    const multiple = document.getElementById('location-count-multiple').checked;
    showError(locationError, (!single && !multiple) ? 'Please select a location option.' : '');

    // Quantity validation
    const quantityInput = document.getElementById('package-quantity');
    const quantityError = document.getElementById('error-contact-amount');
    const quantityValue = parseInt(quantityInput.value.trim(), 10);
    if (!quantityValue || quantityValue < 5) {
      showError(quantityError, 'Please enter a quantity of 5 or more.');
    } else {
      showError(quantityError, '');
    }

    // Message box validation
    const messageInput = document.getElementById('comment-box');
    const messageError = document.getElementById('error-contact-body');
    showError(messageError, messageInput.value.trim() === '' ? 'Please tell us about your project.' : '');

    if (hasError) {
      e.preventDefault();
    }
  });

  // Telephone number formatter
  const tele = document.querySelector('input[type="tel"]');
  tele.addEventListener('keyup', function(e){
    if (event.key !== 'Backspace' && (tele.value.length === 3 || tele.value.length === 7)){
      tele.value += '-';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact--template"]) return;
  try {
    
document.querySelector('.contact__form .btn').addEventListener('click', (e) => {

  let hasError = false;

  const showError = (errorElement, message) => {
    if (message) {
      errorElement.textContent = message;
      errorElement.classList.add('error');
      hasError = true;
    } else {
      errorElement.textContent = '';
      errorElement.classList.remove('error');
    }
  };

  const nameInput = document.getElementById('contact-ContactFormName');
  const nameError = document.getElementById('error-contact-name');
  showError(nameError, nameInput.value.trim() === '' ? 'Please add your name.' : '');

  const emailInput = document.getElementById('contact-ContactFormEmail');
  const emailError = document.getElementById('error-contact-email');
  const emailValue = emailInput.value.trim();
  if (emailValue === '') {
    showError(emailError, 'Please add your email address.');
  } else if (!/^\S+@\S+\.\S+$/.test(emailValue)) {
    showError(emailError, 'Please enter a valid email address.');
  } else {
    showError(emailError, '');
  }

  const categoryInput = document.getElementById('contact-ContactFormCategory');
  const categoryError = document.getElementById('error-contact-category');
  showError(categoryError, categoryInput.value === '' ? 'Please select a category.' : '');

  const messageInput = document.getElementById('contact-ContactFormMessage');
  const messageError = document.getElementById('error-contact-body');
  showError(messageError, messageInput.value.trim() === '' ? 'Please add a message.' : '');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["donation-request--template"]) return;
  try {
    
  // Phone number formatter
  const tele = document.querySelector('input[type="tel"]');
  if (tele) {
    tele.addEventListener('blur', function () {
      // Remove all non-digit characters
      const digits = tele.value.replace(/\D/g, '');

      // Format only if 10 digits
      if (digits.length === 10) {
        tele.value = digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
    });
  }


  // Form validation on submit button click
  const submitBtn = document.querySelector('.donation__request input[type="submit"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      let hasError = false;

      const showError = (id, message) => {
        const el = document.getElementById(id);
        if (el) {
          el.textContent = message;
          el.hidden = !message;
          el.setAttribute('aria-hidden', !message);
          if (message) {
            el.classList.add('error');
          } else {
            el.classList.remove('error');
          }
        }
      };

      const form = document.querySelector('.donation__request');

      const name = form.querySelector('[name="contact[organization-name]"]');
      showError('error-org-name', name.value.trim() === '' ? 'Please enter your organization name.' : '');

      const website = document.getElementById('website');
      const websitePattern = /^(https?:\/\/)?(www\.)?[\w-]+\.[a-z]{2,}([\/?#]\S*)?$/i;
      const websiteValue = website.value.trim();
      if (websiteValue === '') {
        showError('website-error', 'Please enter a website or social media link.');
      } else if (!websitePattern.test(websiteValue)) {
        showError('website-error', 'Please enter a valid URL.');
      } else {
        showError('website-error', '');
      }

      // Validate charitable focus radio selection
      const orgFocusRadios = form.querySelectorAll('input[name="contact[organization-focus]"]');
      const orgFocusSelected = Array.from(orgFocusRadios).some(radio => radio.checked);
      showError(
        'error-charitable-area',
        !orgFocusSelected ? 'Please select a focus area.' : ''
      );

      const desc = document.getElementById('org-descript');
      showError('error-org-description', desc.value.trim() === '' ? 'Please describe your organization.' : '');

      const contactName = document.getElementById('contact-name');
      showError('error-contact-name', contactName.value.trim() === '' ? 'Please enter a contact name.' : '');

      const contactEmail = document.getElementById('contact-email');
      const emailPattern = /^\S+@\S+\.\S+$/;
      const emailVal = contactEmail.value.trim();
      if (emailVal === '') {
        showError('error-contact-email', 'Please enter a contact email.');
      } else if (!emailPattern.test(emailVal)) {
        showError('error-contact-email', 'Please enter a valid email.');
      } else {
        showError('error-contact-email', '');
      }

      // Prevent form submission if any error is visible
      const errors = form.querySelectorAll('.error-message');
      errors.forEach((err) => {
        if (!err.hidden) hasError = true;
      });

      if (hasError) {
        e.preventDefault();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
